import { render } from "./Presentation.vue?vue&type=template&id=fb65f58e&scoped=true&ts=true"
import script from "./Presentation.vue?vue&type=script&lang=ts"
export * from "./Presentation.vue?vue&type=script&lang=ts"

import "./Presentation.vue?vue&type=style&index=0&id=fb65f58e&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb65f58e"]])

export default __exports__